import {
    Component,
    OnInit,
    ContentChildren,
    QueryList,
    AfterContentInit,
    Input,
    EventEmitter,
    AfterContentChecked, ChangeDetectorRef, Output
  } from "@angular/core";
  import { SmartTabItem } from "./tab";
  import { Observable, Subscription } from "rxjs";
  import { startWith, map, take, tap, delay } from "rxjs/operators";
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';


  @Component({
    selector: "ess-tabset",
    templateUrl: './tabset.html',
    styleUrls: ['./tabset.scss']
    // template: `
    //   <div class="tabs-header">
    //     <div
    //       class="tab-label"
    //       (click)="selectTab(item)"
    //       [class.active]="activeTab === item"
    //       *ngFor="let item of tabItems$ | async"
    //     >
    //       <ng-container *ngIf="item.labelComponent">
    //         <ng-container *ngTemplateOutlet="item.labelComponent.labelContent">
    //         </ng-container>
    //       </ng-container>
  
    //       <ng-container *ngIf="!item.labelComponent">
    //         {{ item.label }}
    //       </ng-container>
    //     </div>
    //   </div>
    //   <div class="tabs-body">
    //     <ng-container *ngIf="activeTab && activeTab.bodyComponent">
    //       <ng-container *ngTemplateOutlet="activeTab.bodyComponent.bodyContent">
    //       </ng-container>
    //     </ng-container>
    //   </div>
    // `,
    // styles: [
    //   `
    //     .tabs-header {
    //       display: flex;
    //     }
    //     .active {
    //       color: red;
    //     }
  
    //     .tab-label {
    //       border: 1px dashed black;
    //       padding: 25px;
    //       margin: 0 10px;
    //     }
    //   `,
    // ],
  })
  export class SmartTabSet implements AfterContentInit, AfterContentChecked {
    
    @ContentChildren(SmartTabItem)
    tabs: QueryList<SmartTabItem>;
  
    // tabItems$: Observable<SmartTabItem[]>;
  
    // activeTab: SmartTabItem;
    
    /**
     * The index of the selected tab.
     */
    @Input('activeTab')
    activeTab: number;

    /**
     * Event fired when the active tab is changed.
     * <br>
     * The event gives the index of the selected tab.
     */
    @Output('tabChanged')
    onTabChange: EventEmitter<number> = new EventEmitter<number>();
  
    constructor(private sanitizer: DomSanitizer, private changer: ChangeDetectorRef) {}
  
    ngAfterViewInit() {
        this.changer.detectChanges();
    }
    // ngAfterContentInit() {
    //     console.log('header is ' + this.headerHTML);
    //     console.log('body is ' + this.bodyHTML);
    // }

    ngAfterContentInit(): void {
    //   this.tabItems$ = this.tabs.changes
    //     .pipe(startWith(""))
    //     .pipe(delay(0))
    //     .pipe(map(() => this.tabs.toArray()));
    }
  
    ngAfterContentChecked() {
      //choose the default tab
      // we need to wait for a next VM turn,
      // because Tab item content, will not be initialized yet
    //   if (!this.activeTab) {
    //     Promise.resolve().then(() => {
    //       this.activeTab = this.tabs.first;
    //     });
    //   }
    }
  
    // header(tab: SmartTabItem): SafeHtml {
    //     return this.sanitizer.bypassSecurityTrustHtml(tab.headerHTML());
    // }

    // body(tab: SmartTabItem): SafeHtml {
    //     return this.sanitizer.bypassSecurityTrustHtml(tab.headerHTML());
    // }

    // selectTab(tabItem: SmartTabItem) {
    //   if (this.activeTab === tabItem) {
    //     return;
    //   }
  
    //   if (this.activeTab) {
    //     // this.activeTab.isActive = false;
    //   }
  
    //   this.activeTab = tabItem;
  
    //   tabItem.isActive = true;
    // }

    tabChanged(event: number) {
        this.activeTab = event;

        this.onTabChange.emit(this.activeTab);
    }
  }
  